import {useMemo} from 'react'

import {twMerge} from '@sdox/utils'

import {getPlaceholderDataUrl} from './utils'

import type {LazyImageProps} from './LazyImage'

type ImageSkeletonPlaceholderProps = LazyImageProps

export const ImageSkeletonPlaceholder = (props: ImageSkeletonPlaceholderProps) => {
  const {
    src: _,
    placeholderSrc: _p,
    width,
    height,
    className,
    logError: _lE,
    logPlaceholderError: _lPE,
    hasBackground: _hB,
    ...restProps
  } = props

  const src = useMemo(() => getPlaceholderDataUrl(width, height), [width, height])

  return (
    <img
      data-testid={'img-skeleton-placeholder'}
      src={src}
      className={twMerge('bg-media-bg', className)}
      width={width}
      height={height}
      {...restProps}
    />
  )
}
